export type BannedWantedDisplayContext = "adjustment" | "reflection";

type BannedWantedCellVisualStateInput = {
  readonly displayContext: BannedWantedDisplayContext | undefined;
  readonly hasBannedShift: boolean;
  readonly isBannedApplied: boolean;
  readonly isBannedShiftViolation: boolean;
};

type BannedWantedCellVisualState = {
  readonly showBanBadge: boolean;
  readonly showNotAppliedOverlay: boolean;
  readonly showWantedMismatchOverlay: boolean;
};

export function getBannedWantedCellVisualState({
  displayContext,
  hasBannedShift,
  isBannedApplied,
  isBannedShiftViolation,
}: BannedWantedCellVisualStateInput): BannedWantedCellVisualState {
  const showBanBadge =
    hasBannedShift &&
    (displayContext === "adjustment" ||
      (displayContext === "reflection" && isBannedShiftViolation));

  if (!showBanBadge) {
    return {
      showBanBadge: false,
      showNotAppliedOverlay: false,
      showWantedMismatchOverlay: false,
    };
  }

  return {
    showBanBadge: true,
    showNotAppliedOverlay: !isBannedApplied,
    showWantedMismatchOverlay: isBannedShiftViolation,
  };
}
